import React from "react";
import { VertModal } from "@vertem-core/vertice-ds";
import PopBalloonFormToUpdateAddress from "../PopAnimation/PopBalloonFormToUpdateAddress";
import { LegalText } from "../ShowcasePopBallon/BallonModal";
import './ModalCompleteRedemption.less'

export const ModalCompleteRedemption = ({ isOpen, onCancel, getPrizeCallback }) => {
    return (
        <VertModal
            className="modal-update-form-adress"
            open={isOpen}
            onCancel={onCancel}
            onOk={onCancel}
            width={564}
            closable={false}
            footer={<LegalText />}
            centered={true}
        >
            <PopBalloonFormToUpdateAddress
                callback={() => {
                    getPrizeCallback();
                }}
                cancel={() => {
                    onCancel(); // Fecha o modal
                }}
            />
        </VertModal>
    );
};
